import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Center,
  GridItem,
  SimpleGrid,
  VStack,
  Button,
  Heading,
  Spinner,
  Flex,
} from "@chakra-ui/react";
import axios from "axios";
import Navbar from "../components/navbar/Navbar";
import CarCard from "../components/ui/car-card";
import Footer from "../components/footer";
import LoadingSpinner from "../components/ui/loading-spinner";
import SearchInput from "../components/search";
import AvatarMenu from "../components/navbar/avatar-menu";
import HomeSidebarContent from "../components/home/home-sidebar-content";
import NavbarLinks from "../components/navbar/NavbarLinks";
import SearchContext from "../SearchContext";
import ResponsiveAds from "../components/adsense/AdsResponsive";
import ThreeColumnLayout from "../components/adsense/AdsThreeColumnLayout";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

function BookCars() {
  const { searchResults, setSearchResults } = useContext(SearchContext);
  const [cars, setCars] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchCars(currentPage);
  }, [currentPage]);

  const fetchCars = async (page) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${backendUrl}/api/cars?page=${page}`,
      );
      setCars(response.data.data.data);
      setCurrentPage(response.data.data.current_page);
      setTotalPages(response.data.data.last_page);
    } catch (error) {
      console.error("Error fetching cars:", error);
    }
    setLoading(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  if (isLoading) return <LoadingSpinner />;

  return (
    <>
      <Navbar
        sidebarContent={<HomeSidebarContent />}
        links={<NavbarLinks />}
        buttons={<AvatarMenu />}
      />
      <Center>
        <VStack w="full" p={4}>
          <Heading size="lg" mb={4}>
            Available Cars
          </Heading>
          <SimpleGrid
            columns={[1, 1, 2, 2, 3]}
            rowGap={6}
            columnGap={8}
            py={10}
          >
            {searchResults && searchResults.length > 0
              ? searchResults.map((car) => (
                <GridItem key={car.id} colSpan={1}>
                  <CarCard props={car} />
                </GridItem>
              ))
              : cars.map((car) => (
                <GridItem key={car.id} colSpan={1}>
                  <CarCard props={car} />
                </GridItem>
              ))}
          </SimpleGrid>
          <Flex mt={4} justify="center" w="full">
            {Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i + 1}
                onClick={() => handlePageChange(i + 1)}
                disabled={currentPage === i + 1}
                mx={1}
              >
                {i + 1}
              </Button>
            ))}
          </Flex>
        </VStack>
      </Center>
      <ResponsiveAds />
      <ThreeColumnLayout />
      <Footer />
    </>
  );
}

export default BookCars;
